export function getBaseMapStyle(base) {
  // MapTiler styles for hiking
  if (base === "maptiler-outdoor") {
    return "https://api.maptiler.com/maps/outdoor-v2/style.json?key=HXgK2fqnmExz8Z5kpMyR";
  }
  if (base === "maptiler-custom") {
    return "https://api.maptiler.com/maps/0199560f-28c5-7c14-96f4-b53ac84595ba/style.json?key=HXgK2fqnmExz8Z5kpMyR";
  }

  const sources = {
    osm: {
      type: "raster",
      tiles: ["https://tile.openstreetmap.org/{z}/{x}/{y}.png"],
      tileSize: 256,
      attribution: "© OpenStreetMap Contributors",
    },
    opentopomap: {
      type: "raster",
      tiles: [
        "https://a.tile.opentopomap.org/{z}/{x}/{y}.png",
        "https://b.tile.opentopomap.org/{z}/{x}/{y}.png",
        "https://c.tile.opentopomap.org/{z}/{x}/{y}.png",
      ],
      tileSize: 256,
      attribution: "© OpenTopoMap (CC-BY-SA)",
    },
  };
  const style = {
    version: 8,
    sources: {
      osm: {
        type: "raster",
        tiles: sources[base].tiles,
        tileSize: sources[base].tileSize,
        attribution: sources[base].attribution,
      },
      elevation: {
        type: "raster-dem",
        tiles: [
          "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png",
        ],
        tileSize: 256,
        encoding: "terrarium",
        attribution: "© Mapzen Terrain Tiles",
        maxzoom: 14,
      },
    },
    layers: [
      {
        id: "osm",
        type: "raster",
        source: "osm",
        minzoom: 0,
        maxzoom: 19,
      },
    ],
  };

  // Add elevation visualization for hiking maps
  if (base === "opentopomap" || base === "osm") {
    style.sources.elevation = {
      type: "raster-dem",
      tiles: [
        "https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png",
      ],
      tileSize: 256,
      encoding: "terrarium",
      attribution: "© Mapzen Terrain Tiles",
      maxzoom: 14,
    };

    style.layers.push({
      id: "hillshade",
      type: "hillshade",
      source: "elevation",
      paint: {
        "hillshade-shadow-color": "#666",
        "hillshade-highlight-color": "#fff",
        "hillshade-accent-color": "#888",
        "hillshade-exaggeration": 0.5,
      },
    });
  }

  return style;
}
